module.exports = __webpack_public_path__ + "img/new-image-bg-375.4d39511d.png";